<template>
	<div class="w-100">
		<v-card class="w-100" color="#0E0818" style="border-top: 1px solid #958fc550; border-radius: 0">
			<v-card-text
				style="background-color: #0e0818; opacity: 0.9"
				class="pa-2 white--text d-flex align-center justify-space-between">
				<span class="white-p small-text">
					This website uses cookies to ensure you get the best experience. Learn more about our
					<a
						href="https://app.termly.io/document/cookie-policy/62fe313d-54e2-4049-ad26-63f2f7259754"
						target="_blank"
						style="color: #6b96c2">
						Cookies Policy
					</a>
				</span>

				<v-btn size="large" color="#6b96c2" variant="plain" class="normal-spacing" @click="acceptCookies">
					Accept
				</v-btn>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios"
	export default {
		name: "CookieConsent",
		methods: {
			acceptCookies() {
				axios
					.post("/cookie-consent", {
						cookie_consent: true,
					})
					.then((response) => {
						console.log(response.data)
						window.location.reload()
					})
					.catch((error) => {
						console.log(error)
					})
			},
		},
	}
</script>
